const handleOperationChange = (
    menuValue: string,
    setFilter: (fields: Partial<SentenceFilterT>) => void,
) => {
    if (menuValue) {
        const [newOperation, newValue] = menuValue.split('-');
        setFilter({
            operation: newOperation as FilterOperationsT,
            valueScale: null,
            value: newValue,
        });
    }
};

export const handleOperationSubMenuChange =
    (
        menuValue: string,
        setFilter: (fields: Partial<SentenceFilterT>) => void,
    ) =>
    (e: React.MouseEvent<HTMLLIElement, MouseEvent>): void => {
        // This is a hack to lower menu when we select the upper one
        // When we click on an embedded MenuItem, it cascades the click (capture) to the lower one,
        handleOperationChange(menuValue, setFilter);
        e.stopPropagation();
    };
